import Grow, {GrowProps} from '@material-ui/core/Grow';
import * as React from 'react';
import TextBubble, {TextBubbleProps} from '../../../shared/components/TextBubble';
import createComputed from '../createComputed';
import FormSectionsBase, {FormSectionsBaseProps} from './FormSectionsBase';
import {DISPLAY_TYPES, SectionInfo} from './consts';
import FormSection from './FormSection';
import * as _ from 'lodash';
import FormSectionFields from '../FormFields/FormSectionFields';
import {stringToDashed} from 'cl-automation-utils';

export interface FormSectionsWithFieldsProps extends FormSectionsBaseProps {
  sections: SectionInfo[];
}

const FormSectionTitle: React.FunctionComponent<SectionInfo> = React.memo(({name, fieldsInfo}: SectionInfo) => {
  const countedKeys = _.map(_.filter(fieldsInfo, 'addToSectionCount'), 'name');
  if (countedKeys.length > 0) {
    const fieldWithCount = _.find(fieldsInfo, fieldInfo => fieldInfo.countComponent);
    const ExternalCount = fieldWithCount ? fieldWithCount.countComponent : undefined;
    const Count = createComputed<any, any, TextBubbleProps & Pick<GrowProps, 'in'>>({
      fieldNames: countedKeys,
      propsGenerator: values => {
        return {
          in: _.some(countedKeys, countedKey => !_.isNil(values[countedKey])),
          text: _.sumBy(countedKeys, countedKey => _.size(values[countedKey])),
        };
      },
    })(props => (
      <Grow in={props.in}>{_.isUndefined(ExternalCount) ? <TextBubble text={props.text} /> : <ExternalCount />}</Grow>
    ));
    return (
      <React.Fragment>
        {name}
        <Count />
      </React.Fragment>
    );
  }
  return <React.Fragment>{name}</React.Fragment>;
});

const shouldAddPadding = fields => !_.some(fields, field => field.displayType === DISPLAY_TYPES.TABLE);

const FormSectionsWithFields: React.FunctionComponent<FormSectionsWithFieldsProps> = ({
  sections,
  children,
  ...props
}) => {
  return (
    <FormSectionsBase {...props}>
      {children}
      {_.map<SectionInfo>(sections, ({fieldsInfo, name}) => (
        <FormSection
          id={stringToDashed(`${name}`)}
          key={name}
          title={<FormSectionTitle fieldsInfo={fieldsInfo} name={name} />}
        >
          <FormSectionFields
            withPadding={shouldAddPadding(fieldsInfo)}
            defaultGridItemProps={{xs: 3}}
            fieldsInfo={fieldsInfo}
          />
        </FormSection>
      ))}
    </FormSectionsBase>
  );
};

export default FormSectionsWithFields;
